/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Creator_Filter_MeInputs */

const vi_order_creator_filter_me = /** @type {(inputs: Order_Creator_Filter_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn của tôi`)
};

/**

* @param {Order_Creator_Filter_MeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_creator_filter_me = /** @type {((inputs?: Order_Creator_Filter_MeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Creator_Filter_MeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_creator_filter_me(inputs)
});